import { lazy } from "react";

const HolidayPage = lazy(() => import("./main"));
const CreateHolidayPage = lazy(() => import("./create"));
const UpdateHolidayPage = lazy(() => import("./update"));

export { HolidayPage, CreateHolidayPage, UpdateHolidayPage };
